import { Vehicle } from "./types";

export const mockVehicles: Vehicle[] = [
  {
    id: "1",
    plate: "CWJZ750",
    model: "Honda Accord",
    bodyType: "Hatchback",
    capacity: 4,
    packageCapacity: 4,
    status: "Active",
    assignedDriver: "John Smith",
    mileage: 45230
  },
  {
    id: "2",
    plate: "DDZN177",
    model: "Honda CRV",
    bodyType: "SUV",
    capacity: 5,
    packageCapacity: 4,
    status: "Active",
    assignedDriver: "Sarah Johnson",
    mileage: 32100
  },
  {
    id: "3",
    plate: "CWAW364",
    model: "Nissan Rogue",
    bodyType: "SUV",
    capacity: 4,
    packageCapacity: 4,
    status: "Active",
    mileage: 28450
  },
  {
    id: "4",
    plate: "DDVV105",
    model: "Jeep Compass",
    bodyType: "SUV",
    capacity: 4,
    packageCapacity: 4,
    status: "Active",
    mileage: 51200
  },
  {
    id: "5",
    plate: "CYKZ842",
    model: "Hyundai Elantra",
    bodyType: "Sedan",
    capacity: 4,
    packageCapacity: 4,
    status: "Active",
    mileage: 19800
  },
  {
    id: "6",
    plate: "DFXN949",
    model: "Hyundai Tucson",
    bodyType: "SUV",
    capacity: 4,
    packageCapacity: 4,
    status: "Maintenance",
    mileage: 67500
  },
  {
    id: "7",
    plate: "CHRT139",
    model: "Nissan Sentra",
    bodyType: "Sedan",
    capacity: 4,
    packageCapacity: 4,
    status: "Active",
    mileage: 22300
  },
  {
    id: "8",
    plate: "DALZ102",
    model: "Nissan Qashqai",
    bodyType: "SUV",
    capacity: 4,
    packageCapacity: 4,
    status: "Active",
    mileage: 15600
  },
  {
    id: "9",
    plate: "CWWM372",
    model: "Ford Escape",
    bodyType: "SUV",
    capacity: 4,
    packageCapacity: 4,
    status: "Active",
    mileage: 38900
  },
  {
    id: "10",
    plate: "CR5W421",
    model: "Ford Explorer",
    bodyType: "SUV",
    capacity: 5,
    packageCapacity: 5,
    status: "Active",
    mileage: 42100
  },
  {
    id: "11",
    plate: "CC VOL",
    model: "Volkswagen Jetta",
    bodyType: "Sedan",
    capacity: 4,
    packageCapacity: 4,
    status: "Active",
    mileage: 31200
  }
];